import React from 'react'

import CourseImg from "../../../assets/images/about-4.jpg"
import { Link } from 'react-router-dom'
import { config } from '../config'

const CourseOverview = () => {
    return (
        <section className="about-style-four">
            <div className="auto-container">
                <div className="row clearfix">
                    <div className="col-lg-8 col-md-12 col-sm-12 image-column">
                        <div className="image-box">
                            <figure className="image">
                                <img src={CourseImg} alt="" />
                            </figure>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 content-column">
                        <div className="content-box">
                            <div className="sec-title">
                                <h2>
                                    Quality Driving Training Through One-on-One Practical Teaching
                                </h2>
                                <Link to={`${config.appUrl}book-a-lesson`} className="theme-btn btn-five">
                                    Enroll Now
                                </Link>
                            </div>
                            <div className="inner-box">
                                <div className="text">
                                    <p>
                                        Ready to get started? Enroll today and take the first step towards earning your driving licence with top-quality instruction. We’ll guide you every step of the way!
                                    </p>
                                </div>
                                <div className="inner">
                                    <div className="single-item">
                                        <div className="icon-box">
                                            <i className="bi bi-caret-right-fill fs-5" />
                                        </div>
                                        <h4>Flexible Timings to Fit Your Schedule</h4>
                                        <p className='lineHeight'>
                                            We understand that life can be busy, which is why we offer flexible timings to fit your schedule. No need to worry about making time for lessons—we work around your availability. Whether you're a student, a working professional, or have a tight calendar, we can accommodate your needs and help you achieve your driving goals at a pace that suits you.
                                        </p>
                                    </div>
                                    <div className="single-item">
                                        <div className="icon-box">
                                            <i className="bi bi-caret-right-fill fs-5" />
                                        </div>
                                        <h4>Experienced Instructors Who Make a Difference </h4>
                                        <p className='lineHeight'>
                                            At Precision Driving, our team of experienced Instructors is committed to helping you become a skilled, confident rider. Each of our instructors brings years of experience, ensuring that you receive expert guidance from start to finish. We provide calm, focused instruction designed to make you feel comfortable and prepared for every aspect of driving.
                                        </p>
                                    </div>
                                    <div className="single-item">
                                        <div className="icon-box">
                                            <i className="bi bi-caret-right-fill fs-5" />
                                        </div>
                                        <h4>Standard Vehicles for Your Training </h4>
                                        <p className='lineHeight'>
                                            We use modern, well-maintained vehicles for all our driving lessons. Our cars are equipped with the latest safety features, making them ideal for learners. You can trust that each vehicle meets the highest standards, ensuring a safe and comfortable driving experience during every lesson.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default CourseOverview